@if (showSideBarMenu) {
  <app-side-bar-menu [ngClass]="{'side-menu-blur' : hasBackgroundBlur}"></app-side-bar-menu>
}

<div id="column-flex" [ngClass]="{'content-blur' : hasBackgroundBlur}">
  <div data-cy="click-here-to-trigger-mouse-leave"></div>

  @if (spinnerObservable | async) {
    <app-loading-spinner></app-loading-spinner>
  }

  @if (showStickyHeader) {
    <app-sticky-header></app-sticky-header>
  }

  @if (showBreadcrumbs) {
    <app-breadcrumbs
    [ngClass]="{'before-loading': isLoading, 'breadcrumbs-blur' : hasBackgroundBlur}"></app-breadcrumbs>
  }

  @if (showCarousel) {
    <app-carousel
      [carouselData]="carouselData"
      [carouselSeverityType]="carouselSeverityTypeInfo">
    </app-carousel>
  }

  <div [ngClass]="{'before-loading': isLoading}" id="container" (scroll)="onRouterOutletContainerScroll($event)">
    <div id="router-outlet" #routerOutlet>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

@if (hasBackgroundBlur) {
  <div class="background-blur"></div>
}

